<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">折旧摊销明细表</span></div>
    <div class="margin-right-left margin-top">
      <Tabs :datas="tabDatas" v-model="activeTab" @change="onTabChange"></Tabs>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <DatePicker type="month" v-model="period" format="YYYY-MM" style="width: 140px"
                    :clearable="false"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="loadList">查询</Button>
        <Button @click="doExport">导出</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <table class="dep-table">
        <thead>
        <tr>
          <th>会计期间</th>
          <th>资产编号</th>
          <th>资产类别</th>
          <th>资产名称</th>
          <th>规格型号</th>
          <th>使用部门</th>
          <th>资产原值</th>
          <th>本期折旧</th>
          <th>本年累计折旧</th>
          <th>累计折旧</th>
          <th>减值准备</th>
          <th>资产净值</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in dataList" :key="index">
          <td>{{ item.period }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.categoryName }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.department }}</td>
          <td align="right">{{ item.originalValue | numFormat }}</td>
          <td align="right">{{ item.currentDepreciation | numFormat }}</td>
          <td align="right">{{ item.yearDepreciation | numFormat }}</td>
          <td align="right">{{ item.accumulatedDepreciation | numFormat }}</td>
          <td align="right">{{ item.impairment | numFormat }}</td>
          <td align="right">{{ item.netValue | numFormat }}</td>
        </tr>
        <tr v-if="!dataList.length">
          <td colspan="12" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

export default {
  name: 'AssetsDepreciationList',
  data() {
    return {
      activeTab: 'depreciation',
      tabDatas: [
        {key: 'depreciation', title: '折旧'},
        {key: 'amortization', title: '摊销'}
      ],
      period: moment().format('YYYY-MM'),
      dataList: [],
      loading: false
    }
  },
  methods: {
    onTabChange() {
      this.loadList();
    },
    normalize(item) {
      return Object.assign({
        period: item.period || this.period,
        code: item.code || '',
        categoryName: item.categoryName || '',
        name: item.name || '',
        spec: item.spec || '',
        department: item.department || '',
        originalValue: item.originalValue || 0,
        currentDepreciation: item.currentDepreciation || item.currentAmount || 0,
        yearDepreciation: item.yearDepreciation || 0,
        accumulatedDepreciation: item.accumulatedDepreciation || 0,
        impairment: item.impairment || 0,
        netValue: item.netValue || 0
      }, item);
    },
    loadList() {
      this.loading = true;
      this.$api.report.assetsDepreciation({
        type: this.activeTab,
        period: this.period
      }).then(({data}) => {
        let list = data.results || data.records || data || [];
        this.dataList = list.map(item => this.normalize(item));
      }).catch(() => {
        this.$Message.error(this.activeTab === 'depreciation' ? '折旧明细加载失败' : '摊销明细加载失败');
      }).finally(() => this.loading = false);
    },
    doExport() {
      let headers = ['会计期间', '资产编号', '资产类别', '资产名称', '规格型号', '使用部门', '资产原值',
        '本期折旧', '本年累计折旧', '累计折旧', '减值准备', '资产净值'];
      let rows = this.dataList.map(item => [
        item.period, item.code, item.categoryName, item.name, item.spec, item.department,
        item.originalValue, item.currentDepreciation, item.yearDepreciation,
        item.accumulatedDepreciation, item.impairment, item.netValue
      ]);
      exportCsv(this.activeTab === 'depreciation' ? '折旧明细表' : '摊销明细表', headers, rows);
    },
    doPrint() {
      window.print();
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.dep-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;

  th, td {
    padding: 6px 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }
}
</style>
